module.exports = __webpack_public_path__ + "static/media/B_food_2_length.06d981b3.png";